import moment from 'moment';
import * as React from 'react';
import { formatAsIndianCurrency } from '../../../../utils/currency';

type switchRightProps = {
    dbCommercial: any;
    switchFromScheme: any;
    switchToScheme: any;
    desktopHeading?: boolean;
    stpFlag?: boolean;
};

const SwitchRight = ({
    dbCommercial,
    switchFromScheme,
    switchToScheme,
    desktopHeading = true,
    stpFlag = false,
}: switchRightProps): JSX.Element => {
    return (
        <div className="mf-investment-right redemption-right">
            <div className="heading">
                {desktopHeading && (
                    <h4>
                        {stpFlag ? dbCommercial.stp.stpDetails : dbCommercial.switch.switchDetails}{' '}
                        <img src="/images/rupee-coin.png" alt="icon" />
                    </h4>
                )}
                <div className="profile-details">
                    <div className="profile-details-info">
                        <p> {dbCommercial.redemption.selectedFolio}</p>
                        <h6>{switchFromScheme.folio}</h6>
                    </div>
                </div>
                <h2>{dbCommercial.switch.switchFrom}</h2>
                <p className="mf-name">
                    <img src={`/images/fav-logos/${switchToScheme.fundLogo}`} alt="icon" />
                    {switchFromScheme.schemeName}
                </p>
            </div>
            <div className="profile-details">
                <div className="profile-details-info">
                    <p>{dbCommercial.redemption.totalBalanceUnits}</p>
                    <h6>{switchFromScheme.availableUnits}</h6>
                </div>
                <div className="profile-details-info">
                    <p>{dbCommercial.redemption.totalAmount}</p>
                    <h6>{`${formatAsIndianCurrency(switchFromScheme.availableAmount)}`}</h6>
                </div>
                <div className="profile-details-info current-nav">
                    <p>{dbCommercial.redemption.currentNav}</p>
                    <div>
                        <h6>{`${formatAsIndianCurrency(switchFromScheme.nav)}`}</h6>
                        <p>
                            <img src="/images/calender-icon.svg" alt="icon" />
                            {dbCommercial.redemption.asOn}
                            <b>{switchFromScheme.navDate}</b>
                        </p>
                    </div>
                </div>
            </div>
            <div className="switch-to heading">
                <h2>{dbCommercial.switch.switchTo}</h2>
                <p className="mf-name">
                    <img src={`/images/fav-logos/${switchToScheme.fundLogo}`} alt="icon" />
                    {switchToScheme.schemeName}
                </p>
            </div>
            {/* <div className="profile-details">
                <div className="profile-details-info current-nav">
                    <p>{dbCommercial.redemption.currentNav}</p>
                    <div>
                        <h6>{`${formatAsIndianCurrency(switchToScheme.nav)}`}</h6>
                        <p>
                            <img src="/images/calender-icon.svg" alt="icon" />
                            {dbCommercial.redemption.asOn}
                            <b>{moment(switchToScheme.navDate).format('DD-MMM-YYYY')}</b>
                        </p>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default React.memo(SwitchRight);
